import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { BibliographicResourceService } from './bibliographic-resource.service';

@NgModule({
  imports: [CommonModule, TarlV3JsonapiModule],
  providers: [BibliographicResourceService],
})
export class BibliographicResourceModule {}
